import { useEffect, useState, ChangeEvent } from "react";
import { InputGroup, Input, Popover, Whisper } from "rsuite";
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';

const COMMON_DOMAINS = ['@gmail.com', '@outlook.com', '@hotmail.com', '@yahoo.com', '@live.com'];

interface UserCustomEmailInputProps {
    values: {
        user_custom_email: string;
    };
}

export default function UserCustomEmailInput({ values }: UserCustomEmailInputProps) {
    const [email, setEmail] = useState(values.user_custom_email);
    const [isValid, setIsValid] = useState<boolean | null>(null);
    const [suggestions, setSuggestions] = useState<string[]>([]);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    useEffect(() => {
        setEmail(values.user_custom_email);
    }, [values.user_custom_email]);

    const handleInputChange = (value: string) => {
        const trimmed = value.trimStart();
        setEmail(trimmed);
        values.user_custom_email = trimmed;
    
        const [local, domain] = trimmed.split("@");
        if (domain === "" && local) {
            setSuggestions(COMMON_DOMAINS.map(d => `${local}${d}`));
        } else {
            setSuggestions([]);
        }
    
        setIsValid(null);
    };

    const handleBlur = () => {
        const trimmed = email.trim();
        setEmail(trimmed);
        values.user_custom_email = trimmed;
        setIsValid(emailRegex.test(trimmed));
    };

    const handleSelectSuggestion = (e: React.MouseEvent, suggestion: string) => {
        e.preventDefault();
        e.stopPropagation();
        setEmail(suggestion);
        values.user_custom_email = suggestion;
        setSuggestions([]);
        setIsValid(emailRegex.test(suggestion));
    };

    const renderPopover = (
        <Popover full>
            {suggestions.map((item, index) => (
                <div
                    key={index}
                    onMouseDown={(e) => handleSelectSuggestion(e, item)}
                    style={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        borderBottom: index !== suggestions.length - 1 ? "1px solid #f0f0f0" : undefined
                    }}
                >
                    {item}
                </div>
            ))}
        </Popover>
    );

    const emptyPopover = <Popover full style={{ display: 'none' }} />;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '.25rem' }}>
            <label htmlFor="email">Email</label>
            <Whisper
                placement="bottomStart"
                trigger="focus"
                speaker={suggestions.length > 0 ? renderPopover : emptyPopover}
            >
                <InputGroup inside style={{ width: '100%', borderRadius: '6px' }}>
                    <Input
                        placeholder="Digite seu e-mail"
                        value={email}
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        type="email"
                        autoComplete="off"
                    />

                    <InputGroup.Addon>
                        {isValid === true && <CheckIcon style={{ color: "green" }} />}
                        {isValid === false && <CloseIcon style={{ color: "red" }} />}
                    </InputGroup.Addon>
                </InputGroup>
            </Whisper>
        </div>
    );
}
